module.exports = __webpack_public_path__ + "img/sec2_2_.450a6f46.png";